import { stringify } from 'src/core/hooks/use-translation'
import { boolean, object, setLocale, string } from 'yup'

setLocale({
  mixed: {
    default: 'common.required',
    notType: 'common.required',
    required: 'common.required'
  }
})

export default object().shape({
  active: string().notRequired(),
  automatic_conference: boolean().required(),
  code: string()
    .required()
    .max(
      250,
      stringify('web.setup.form.field-title.max-character-error', {
        value: 250
      })
    ),
  consensual_conference: boolean().required(),
  cost_center_conference: boolean().required(),
  description: string()
    .max(
      250,
      stringify('web.setup.form.field-title.max-character-error', {
        value: 250
      })
    )
    .notRequired(),
  exception_checker: boolean().required(),
  name: string()
    .required()
    .max(
      250,
      stringify('web.setup.form.field-title.max-character-error', {
        value: 250
      })
    ),
  // policy_conference_id: string().notRequired(),
  reason_conference: boolean().required()
})
